// components/PricingBreadcrumb.jsx
import React from "react";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";

const PricingBreadcrumb = ({ current }) => (
    <Breadcrumb style={{ marginBottom: 24, padding: "10px 24px" }}>
        <Breadcrumb.Item>
            <Link to="/pricing">Choix du profil</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{current}</Breadcrumb.Item>
    </Breadcrumb>
);

export default PricingBreadcrumb;
